import { useMemo, useState } from "react";
import Info from "./Info";

export default function RiskManagement() {
  const [store, setStore] = useState({
    accountSize: 0,
    entryPrice: 0,
    takeProfitPrice: 0,
    stopLossPrice: 0,
    riskPerTradePercentage: 0,
  });

  const takeProfitPercentage = useMemo(() => {
    return store.entryPrice > 0
      ? Math.abs((store.takeProfitPrice / store.entryPrice) * 100 - 100)
      : 0;
  }, [store.takeProfitPrice, store.entryPrice]);

  const stopLossPercentage = useMemo(() => {
    return (store.entryPrice > 0 ? Math.abs((store.stopLossPrice / store.entryPrice) * 100 - 100) : 0)
  }, [store.entryPrice, store.stopLossPrice]);

  const leverage = useMemo(() => {
    console.log(stopLossPercentage);
    return stopLossPercentage > 0
      ? Math.round(store.riskPerTradePercentage / stopLossPercentage)
      : 0;
  }, [store.riskPerTradePercentage, stopLossPercentage]);

  const profits = useMemo(() => {
    return (leverage * Number(store.accountSize * takeProfitPercentage)) / 100;
  }, [store.accountSize, takeProfitPercentage, leverage]);

  const riskPerTrade = useMemo(() => {
    return Number(store.accountSize * (stopLossPercentage * leverage)) / 100;
  }, [store.accountSize, stopLossPercentage, leverage]);

  return (
    <div class="flex">
      <div class="mx-auto flex-auto content-center items-center">
        <form class="w-full max-w-sm flex-auto mt-4 mb-4 ml-4">
          <div class="md:flex md:items-center mb-6 mt-6">
            <div class="md:w-1/3">
              <label
                class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                for="inline-full-name"
              >
                Tamano de cuenta
              </label>
            </div>
            <div class="md:w-2/3">
              <input
                class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="inline-full-name"
                type="number"
                placeholder="Account Size"
                min="0"
                step=".01"
                value={store.accountSize}
                onChange={(e) =>
                  setStore({ ...store, accountSize: e.target.value })
                }
              />
            </div>
            <label>USDT</label>
          </div>
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label
                class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                for="inline-full-name"
              >
                Riesgo por trade
              </label>
            </div>
            <div class="md:w-2/3">
              <input
                class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="inline-full-name"
                type="number"
                placeholder="Risk Per Trade"
                min="0"
                step=".01"
                value={store.riskPerTradePercentage}
                onChange={(e) =>
                  setStore({ ...store, riskPerTradePercentage: e.target.value })
                }
              />
            </div>
            <label>%</label>
          </div>
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label
                class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                for="inline-full-name"
              >
                Precio de entrada
              </label>
            </div>
            <div class="md:w-2/3">
              <input
                class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="inline-full-name"
                type="number"
                placeholder="Entry Price"
                min="0"
                step=".01"
                value={store.entryPrice}
                onChange={(e) =>
                  setStore({ ...store, entryPrice: e.target.value })
                }
              />
            </div>
          </div>
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label
                class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                for="inline-full-name"
              >
                Precio [Stop Loss]
              </label>
            </div>
            <div class="md:w-2/3">
              <input
                class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="inline-full-name"
                type="number"
                placeholder="Stop Loss Price"
                step=".01"
                min="0"
                value={store.stopLossPrice}
                onChange={(e) =>
                  setStore({ ...store, stopLossPrice: e.target.value })
                }
              />
            </div>
          </div>
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/3">
              <label
                class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                for="inline-full-name"
              >
                Precio [Take Profit]
              </label>
            </div>
            <div class="md:w-2/3">
              <input
                class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                id="inline-full-name"
                type="number"
                placeholder="Take Profit Price"
                step=".01"
                min="0"
                value={store.takeProfitPrice}
                onChange={(e) =>
                  setStore({ ...store, takeProfitPrice: e.target.value })
                }
              />
            </div>
          </div>
          {/* <div class="md:flex md:justify-end md:items-center mb-6">
                        <input class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded w-2/3" type="submit" value="Calcular" />
                    </div> */}
        </form>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Detalles del trade
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            Configuraci&oacute;n del trade
          </p>
        </div>
        <div className="border-t border-gray-200">
          <dl>
            <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500 font-bold flex items-center">
                Apalancamiento
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 font-bold">
                <div class="flex justify-around items-center">
                  <span>{leverage}x</span>
                  <div className="block w-40 h-10">
                    <Info riskPerTrade={store.riskPerTradePercentage} stopLossPercentage={stopLossPercentage} leverage={leverage}></Info>
                  </div>
                </div>
              </dd>
            </div>
            <div className="bg-green-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                % de Ganancia:
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {(takeProfitPercentage.toFixed(2) * leverage).toFixed(2)}%
              </dd>
            </div>
            <div className="bg-green-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Ganancia:</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                ${profits.toFixed(2)}
              </dd>
            </div>
            <div className="bg-green-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Balance de cuenta + Ganancia:
              </dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                ${(Number(profits) + Number(store.accountSize)).toFixed(2)}
              </dd>
            </div>
            <div className="bg-red-100">
              <div className="bg-red-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  % de Perdida:
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  {(stopLossPercentage.toFixed(2) * leverage).toFixed(2)}%
                </dd>
              </div>
              <div className="bg-red-100 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  Posible perdida:
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  ${riskPerTrade.toFixed(2)}
                </dd>
              </div>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
